/* eslint-disable no-undef */
import React, { useState, useEffect } from 'react';
import { makeStyles } from '@material-ui/core/styles';
import { Backdrop, Zoom, FormControlLabel, Checkbox, IconButton, CircularProgress } from '@material-ui/core';
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';
import CancelIcon from '@material-ui/icons/Cancel';
import { v4 } from 'uuid';

const useStyles = makeStyles((theme) => ({
  backdrop: {
    zIndex: theme.zIndex.drawer + 1,
    color: '#fff',
  },
}));
export default ({ file, onDelete, url }) => {
  const classes = useStyles();
  const [obj, set_obj] = useState(file);
  const [is_loading, set_is_loading] = useState(false);
  const [is_canny, set_is_canny] = useState(false);
  const [is_histogram, set_is_histogram] = useState(false);
  const [is_zoom, set_is_zoom] = useState(false);
  const [is_expand, set_is_expand] = useState(true);
  const [id] = useState(v4());

  useEffect(() => {
    if (url) {
      fetch(url).then(async r => {
        const data = await r.blob();
        const metadata = { type: 'image/jpeg' };
        set_obj(new File([data], 'test.jpg', metadata));
      });
    }
  }, [url]);

  useEffect(() => {
    if (is_canny || is_histogram) {
      set_is_loading(true);
      setTimeout(() => {
        const src = cv.imread(id);
        const dst = new cv.Mat();
        // cv.cvtColor(src, src, cv.COLOR_RGB2GRAY, 0);
        // You can try more different parameters
        if (is_canny) {
          cv.Canny(src, dst, 50, 100, 3, false);
        } else if (is_histogram) {
          cv.cvtColor(src, src, cv.COLOR_RGBA2GRAY, 0);
          cv.equalizeHist(src, dst);
        }
        // cv.equalizeHist(src, dst);
        cv.imshow(id + '-canvas', dst);
        src.delete();
        dst.delete();
        set_is_loading(false);
      }, 500);
    } else {
      set_is_loading(false);
    }
  }, [is_canny, is_histogram, obj]);

  if (!obj) return null;
  return (
    <>
      <div className="thumbnail-image-container-interactive w-100 h-100">
        {!!onDelete && <div className="button" children="x" onClick={onDelete} />}
        <img className="w-100 h-100" src={URL.createObjectURL(obj)} onClick={() => set_is_zoom(true)} />
      </div>
      <Backdrop
        className={classes.backdrop}
        open={is_zoom}
      // onClick={() => set_is_zoom(false)}
      >
        <Zoom in={!!is_zoom}>
          <>
            <div className="p-2 rounded fixed-top d-flex justify-content-between" style={{ background: '#030303bb' }}>
              {is_expand ? (
                <div className="d-flex flex-column">
                  <FormControlLabel
                    control={<Checkbox checked={is_histogram} onChange={e => set_is_histogram(e.target.checked)} color="secondary" />}
                    label="Histogram Equalization"
                  />
                  <FormControlLabel
                    control={<Checkbox checked={is_canny} onChange={e => set_is_canny(e.target.checked)} color="secondary" />}
                    label="Canndy Edge"
                  />
                </div>
              )
                : <div>Filter</div>}
              <div className="col-2 d-flex justify-content-end align-items-start">
                <IconButton onClick={() => set_is_expand(f => !f)}>
                  <ExpandMoreIcon
                    style={{ color: 'white', transform: `rotate(${is_expand ? 180 : '0'}deg)`, transition: 'all 0.3s ease-in-out' }}
                  />
                </IconButton>
                <IconButton onClick={() => set_is_zoom(false)}>
                  <CancelIcon style={{ color: 'white' }} />
                </IconButton>
              </div>
            </div>
            <div className="position-relative vh-100 wh-100">
              {(is_canny || is_histogram) && <canvas className="position-absolute" id={id + '-canvas'} />}
              {is_loading && (
                <div
                  className="position-absolute d-flex justify-content-center align-items-center"
                  style={{ width: '100%', height: '100%' }}
                >
                  <CircularProgress />
                </div>
              )}
              <img id={id} src={URL.createObjectURL(obj)} className="vh-100 wh-100" />
            </div>
          </>
        </Zoom>
      </Backdrop>
    </>
  );
};
